/*
 * Copyright (C) Luna Srl - All Rights Reserved
 *
 * @project    bfree-frontend.nosync
 * @file       CollaborationTitleImage.tsx
 * @author     Christian Ascone
 * @date       10/14/19 2:58 PM
 */

import React from 'react';
import {Image} from "react-native";

export function CollaborationTitleImage(props) {
    return (
        <Image
            {...props}
            style={[props.style]}
            source={
                require('../../assets/images/collaboration_title_image.png')
            }
        />
    );
}